import { registerStoreSpecs } from '@blocksuite/affine/extensions';

registerStoreSpecs();
